<script setup>
  import { ref } from "vue";
  import { Loader2 } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";

  const props = defineProps({
    canTrigger: { type: Boolean, required: true },
    actionFunction: { type: Function, required: true },
    content: { type: String, default: "Save" },
    loading: { type: Boolean, default: false },
    hasErrors: { type: Boolean, default: false },
  });

  const isLoading = ref(false);

  const handleAction = async () => {
    isLoading.value = true;
    await props.actionFunction();
    isLoading.value = false;
  };
</script>

<template>
  <Button
    :variant="hasErrors ? 'destructive' : 'default'"
    :disabled="isLoading || !canTrigger"
    @click="handleAction">
    <Loader2
      v-if="isLoading || loading"
      class="h-4 w-4 mr-2 animate-spin" />
    {{ content }}
  </Button>
</template>
